// Tracks booking writes currently in flight, keyed on booking id. WebSocket
// echoes for a booking must not overwrite a field while a write to that same
// booking is still outstanding: the echo can predate the edit the save is
// about to persist. Ref-counted because overlapping writes (a replayed
// offline save plus a user edit) can target the same booking.
//
// Kept deliberately dependency-free (no React, no API imports) so both the
// write path (APIs/Booking) and the merge path (utils/booking.ts) can share
// it without an import cycle.
const inFlightBookingWrites = new Map<string, number>();

export const markBookingWriteInFlight = (bookingId?: string): void => {
  if (!bookingId) return;
  inFlightBookingWrites.set(
    bookingId,
    (inFlightBookingWrites.get(bookingId) ?? 0) + 1
  );
};

export const clearBookingWriteInFlight = (bookingId?: string): void => {
  if (!bookingId) return;
  const remaining = (inFlightBookingWrites.get(bookingId) ?? 0) - 1;
  if (remaining <= 0) {
    inFlightBookingWrites.delete(bookingId);
  } else {
    inFlightBookingWrites.set(bookingId, remaining);
  }
};

export const hasBookingWriteInFlight = (bookingId?: string): boolean =>
  !!bookingId && (inFlightBookingWrites.get(bookingId) ?? 0) > 0;
